import { render } from "./RegistrationPage.vue?vue&type=template&id=dec392cc&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=js"
export * from "./RegistrationPage.vue?vue&type=script&lang=js"

import "./RegistrationPage.vue?vue&type=style&index=0&id=dec392cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec392cc"]])

export default __exports__